import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getFuelStationEvents(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENTS,
    options
  )
}

function _getFuelStationEvent(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT,
    options
  )
}

function _getFuelStationEventPreview(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_PREVIEW,
    options
  )
}

function _getFuelStationEventPopup(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_POPUP,
    options
  )
}

function _patchFuelStationEvent(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].PATCH_FUEL_STATION_EVENT,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENTS]: _getFuelStationEvents,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT]: _getFuelStationEvent,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_PREVIEW]: _getFuelStationEventPreview,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_POPUP]: _getFuelStationEventPopup,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].PATCH_FUEL_STATION_EVENT]: _patchFuelStationEvent
}
